import TagManager, { TagManagerArgs } from "react-gtm-module";
import { HostEnvironments, isFeatureBranch } from "../config/env";

const TAG_MANAGER_ID_BY_ENV: Record<string, string> = {
  [HostEnvironments.PROD]: "GTM-NXBTBZ2",
  [HostEnvironments.BETA]: "GTM-MKXPLNC",
  [HostEnvironments.DEV]: "GTM-MVFVZWL",
  [HostEnvironments.LOCAL]: "GTM-MVFVZWL",
};

export const initializeTagManager = (): void => {
  // IF statement blocks initialising TagManager on local or anywhere we don't want to initialize.
  if (Object.values(HostEnvironments).includes(window.location.host) || isFeatureBranch) {
    const proxyHost = isFeatureBranch ? HostEnvironments.DEV : window.location.host;
    const tagManagerArgs: TagManagerArgs = {
      gtmId: TAG_MANAGER_ID_BY_ENV[proxyHost],
    };

    TagManager.initialize(tagManagerArgs);
  }
};
